import React from "react";
import styles from "./SearchBarContainer.m.sass";

import debounce from 'lodash-es/debounce';
import SearchResultsContainer from '../searchResultsContainer/SearchResultsContainer';

export default class SearchBarContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {searchInput: '', searchQuery: false, isFocused: false};
  }

  onFocus = () => this.setState({isFocused: true});
  onBlur = () => setTimeout(() => this.setState({isFocused: false}), 0);

  executeSearch = () => {
    const {searchInput} = this.state;

    if (!searchInput) {
      return;
    }

    this.setState({searchQuery: searchInput})
  };

  debouncedExecuteSearch = debounce(this.executeSearch, 500);

  handleSearchChange = (e) => {
    this.setState({searchInput: e.target.value});
    this.debouncedExecuteSearch();
  };

  handleKeyPress = (e) => {
    this.debouncedExecuteSearch.cancel();

    if (e.key === 'Enter') {
      this.executeSearch();
    }
  };

  clearInput = () => {
    this.setState({searchInput: '', searchQuery: false});
  };

  render() {
    const {searchInput, searchQuery, isFocused} = this.state;

    return (
      <div className={styles.searchBar}>
        <div className={styles.searchBarWrapper}>
          <input
            type="text"
            className={styles.searchBarInput}
            value={searchInput}
            onChange={this.handleSearchChange}
            onKeyPress={this.handleKeyPress}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            placeholder="Search"
            required
          />

          <span className={styles.searchBarIcon}/>

          <button
            onClick={this.clearInput}
            className={styles.searchBarClear}
          >
            <span/>
            <span/>
          </button>
        </div>

        {(searchInput && isFocused) && (
          <div className={styles.searchBar_resultList}>
            <div className={styles.searchBar_resultListContent}>
              <SearchResultsContainer query={searchQuery}/>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/searchBarContainer/SearchBarContainer.js